module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/imgBG_ownership-f967e5cb47385a2031f918819fb073c3.png";